import React, { Component, } from "react";
import DB from "../../DB/firebase";
import { Card, Row, Col, Button, Table, Tag, Space, Alert } from "antd";

const { Meta } = Card;
class Refund extends Component {
  constructor(props) {
    super(props);
    this.state = { 
      data: [], 
      screen: 1, 
      details: [], 
      index : 0,
      Price: 0,
      accountID: '',
      showAlert: false,
      successAlert: false,
      successMessage: '',
    };
  }
  componentDidMount() {
    DB.firestore()
      .collection("ClientBooking")
      .onSnapshot((item) => {
        let arr = [];
        item.docs.map((doc) => {
          arr.push({
            id: doc.id,
            ...doc.data(),
          });
        });
        this.setState({ data: arr }, () => {
        });
      });
  }

  refundFunction = (e) => {
    e.preventDefault();
    if (this.state.accountID) {
      let data = this.state.details
      if(data[this.state.index].refund === true){
        var amount = this.state.Price
      var myHeaders = new Headers();
      var accountID = this.state.accountID
      myHeaders.append("Authorization", "Bearer sk_test_51JP90CD8e62COta8xUcJrEnBq5DctTM1JO2gb17k3nqOJi9tN5UvjLMMjI4UdKTAk3WspoWmeejTBOfkh0TV9yQZ00KVebWgmv");
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        redirect: 'follow'
      };
      fetch("https://api.stripe.com/v1/transfers?amount=" + amount + "&currency=usd&destination=" + accountID, requestOptions)
        .then(response => response.json())
        .then(result => {
          let data = this.state.details
          data[this.state.index].refund = false
          DB.firestore()
          .collection('ClientBooking')
          .doc(data[0].UserId)
          .update({
            Details : data
          })
          this.setState({
            showAlert: false,
            index: 0,
            Price: 0,
            accountID: '',
            details: data,
            successMessage: 'The amount has been send successfully!',
            successAlert: true,
          })
        })
        .catch(error => {
          return false
        });
      }else{
        this.setState({
          showAlert: false,
          successMessage: 'The Amount has been already send',
          successAlert: true,
        })
      }

    }else{
      alert('Please Ask the client to add Bank account Information.')
    }
   
  }

  _renderAlert = () => {
    return(
      <Alert
      message="Refund"
      description={"Are you sure you want to refund the Amount of $"+this.state.Price/100 +"? for this service"}
      type="info"
      action={
        <Space direction="vertical">
          <Button size="small" type="primary"
            onClick={(e) => {this.refundFunction(e)}}
          >
            Accept
          </Button>
          <Button size="small" danger type="ghost"
            onClick={(e) => {
              e.preventDefault();
              this.setState({
                showAlert: false,
                index: 0,
                Price: 0,
                accountID: '',
              })
            }}
          >
            Decline
          </Button>
        </Space>
      }
      closable
    />
    );
  }

  _renderSuccessAlert = () => {
    return(
      <Alert message={this.state.successMessage} type="success" closable 
      afterClose={() => {
        this.setState({
          successAlert: false,
        })
      }
      } />
    )
  }
  render() {
    if (this.state.screen === 1) {
      return (
        <div>
          <Row>
            {this.state.data.map((val) => {
              if (val.Details && val.Details.length > 0) {
                return (
                  <Col span={8}>
                    <Card
                      onClick={() => {
                        this.setState({ screen: 2, details: val.Details });
                      }}
                      hoverable
                      style={{ width: 240, marginBottom: 22 }}
                      cover={
                        <img
                          alt="example"
                          src={val?.Details[0]?.ProviderprofileImage ?? "N/A"}
                        />
                      }
                    >
                      <Meta
                        title={val?.Details[0]?.ProviderName ?? "N/A"}
                        description={""}
                      />
                    </Card>
                  </Col>
                );
              }
            })}
          </Row>
        </div>
      );
    } else {
      const columns = [
        {
          title: "Provider Name",
          dataIndex: "ProviderName",
          key: "name",
        },
        {
          title: "Pricee",
          dataIndex: "Price",
          key: "Price",
        },
        {
          title: "Service",
          dataIndex: "Service",
          key: "Service",
        },
        {
          title: "Client start",
          key: "startPictureClient",
          dataIndex: "ProviderstartPictureClientprofileImage",
          render: (ProviderprofileImage) => (
            <img src={ProviderprofileImage} height={40} width={40}></img>
          ),
        },

        {
          title: "Provider start",
          key: "startPictureProvider",
          dataIndex: "startPictureProvider",
          render: (ProviderprofileImage) => (
            <img src={ProviderprofileImage} height={40} width={40}></img>
          ),
        },
        {
          title: "Client end",
          key: "endPictureClient",
          dataIndex: "endPictureClient",
          render: (ProviderprofileImage) => (
            <img src={ProviderprofileImage} height={40} width={40}></img>
          ),
        },
        {
          title: "provider end",
          key: "endPictureProvider",
          dataIndex: "endPictureProvider",
          render: (ProviderprofileImage) => (
            <img src={ProviderprofileImage} height={40} width={40}></img>
          ),
        },
        {
          title: "Reason",
          dataIndex: "reasonText",
          key: "reasonText",
        },
        {
          title: "Action",
          key: "action",
          render: (text, record, index) => (
            <Space size="middle">
              <Button href="javascript" onClick={(e) => { 
                // this.refundFunction(text.accountID, text.Price, index,e)
                e.preventDefault();
                this.setState({
                  accountID: text.accountID,
                  Price: text.Price*100,
                  index: index,
                  showAlert: true,
                })
              }}>
                Refund
              </Button>
            </Space>
          ),
        },
      ];

      return (
        <div>
          <Button
            type="link"
            onClick={() => {
              this.setState({ screen: 1 });
            }}
          >
            Back
          </Button>
          {
            this.state.showAlert ? (
              this._renderAlert()
            ):(null)
          }
          {
            this.state.successAlert ? (
              this._renderSuccessAlert()
            ):(null)
          }
          <Table columns={columns} dataSource={this.state.details} />
        </div>
      );
    }
  }
}

export default Refund;
